import { API, getAuthHeaders } from './axiosInstance'
import {APIUrlencoded} from "../../src/API/axiosInstance";
import {getUser, updateUser} from "../../src/utilities/utilities";
import moment from 'moment'
import {prop} from "ramda";

export const getBookInfo = (id) =>
  API.get(`/reader/documentInformation?fast_hash=${id}`, getAuthHeaders()).then(res => res.data)

export const getBookWithMeta = (id) =>
  API.get(`/fileops/info/?fast_hash=${id}&include_metadata=true`, getAuthHeaders()).then(res => res.data)

export const getNotes = (id) =>
  API.get(`/notes?fast_hash=${id}`, getAuthHeaders()).then(res => res.data)

export const getNote = (noteId, id) =>
  API.get(`/notes/${noteId}?fast_hash=${id}`, getAuthHeaders()).then(res => res.data)

export const updateReadPosition = ({read_position, id}) =>
  API.post(`/books/read-position?fast_hash=${id}`, read_position, getAuthHeaders()).then(res => res.data)

export const updateFavorite = ({status, id}) => {
  API.post(`/fileops/info/${encodeURIComponent(id)}`, {
    favorite: { value: status }
  }, getAuthHeaders()).then(res => res.data)
}

export const deleteNote = ({ id, path }) =>
  API.delete(`/notes/${encodeURIComponent(id)}?fast_hash=${path}`, getAuthHeaders()).then(res => res.data)

export const addNote = ({ note, path }) =>
  API.post(`/notes?fast_hash=${path}`, note, getAuthHeaders()).then(res => res.data)

export const updateNote = ({id, note, path}) =>
  API.post(`/notes/${encodeURIComponent(id)}?fast_hash=${path}`, note, getAuthHeaders()).then(res => res.data)

export const refreshToken = () =>
  APIUrlencoded.post('/auth/renew-token', {
    grant_type: 'refresh_token',
    refresh_token: getUser().refresh_token
  }, getAuthHeaders()).then(({data}) => {
    const updatedCreds = {
      ...data,
      expiresAt: moment().add(prop('expires_in', data), 'seconds')
    }
    updateUser(updatedCreds)
    return getUser()
  })



// WEBPACK FOOTER //
// ./src/API/reader.js